import { OpenAPI as OpenAPIGeocoder } from '@/modules/api-geocoder';
import { OpenAPI as OpenAPIRouting } from '@/modules/api-routing';

OpenAPIRouting.BASE = `${import.meta.env.VITE_MOBILITY_API_ORIGIN || window.location.origin}/mobilityapi-datsim`;
OpenAPIGeocoder.BASE = `${import.meta.env.VITE_GEOCODER_API_ORIGIN || window.location.origin}/geocoding`;
